<template>
  <CourseBlock
    theme="grey"
    class="authors"
  >
    <template #title>
      {{ title }}
    </template>

    <template #content>
      <ul class="authors__list">
        <li
          v-for="(author, i) in slicedAuthors"
          :key="i"
          class="authors__item"
        >
          <UiAuthor
            :author="author"
            class="authors__card"
          />
        </li>
      </ul>

      <UiButton
        v-if="authors.length > 2"
        theme="quaternary"
        size="big"
        stretch
        @click="isExpanded = !isExpanded"
      >
        {{ isExpanded ? 'Скрыть' : 'Показать ещё' }}
      </UiButton>
    </template>
  </CourseBlock>
</template>

<script setup lang="ts">
  import UiAuthor from '@academica-box/components/Blocks/UiAuthor/UiAuthor.vue'
  import UiButton from '@academica-box/components/Buttons/UiButton/UiButton.vue'
  import type { Author } from '@academica-box/components/Blocks/UiAuthor/types'
  import CourseBlock from '@/components/CourseBlock.vue'

  const props = defineProps<{
    title: string;
    authors: Author[];
  }>()

  const isExpanded = ref(false)

  const slicedAuthors = computed(() => {
    return isExpanded.value ? props.authors : [...props.authors].splice(0, 2)
  })
</script>

<style lang="scss">
  @use '@academica-box/utils/styles/mixins/UiReset' as *;
  @use '@academica-box/utils/styles/mixins/UiMedia' as *;

  .authors__list {
    @include ulres;

    @include media(md, md-max) {
      display: grid;
      grid-gap: 6px;
      grid-template-columns: 1fr 1fr;
    }

    &:not(:last-child) {
      margin-bottom: 20px;

      @include media(lg) {
        margin-bottom: 32px;
      }
    }
  }

  .authors__item {
    &:not(:last-child) {
      margin-bottom: 6px;

      @include media(md) {
        margin-bottom: 0;
      }

      @include media(lg) {
        margin-bottom: 16px;
      }
    }
  }

  .authors__card {
    height: 100%;
  }
</style>
